export default __webpack_public_path__ + "static/media/a011-market-3.5b795b91.svg";